import React from 'react';
import type { CandidateInvoice } from '../../lib/reconciliationApi';
import { formatCurrency } from '../../utils/priceUtils';
import { formatDate } from '../../utils/dateFormat';

// D157.2: the invoice's own number, else its file, said to be a file.
export const candidateNumber = (vi: CandidateInvoice) => vi.invoiceNumber || `file: ${vi.fileName || vi._id.slice(-6)}`;

/**
 * One vendor invoice as every picker shows it (D157.2, D157.2b): number, printed date, total in its own
 * currency (none stated, no label), vessels and registered vendor; `matchLabel` marks a match. Cells only.
 */
export const CandidateInvoiceCells: React.FC<{ vi: CandidateInvoice; matchLabel: string }> = ({ vi, matchLabel }) => (
  <>
    <span className="w-36 truncate font-mono">{candidateNumber(vi)}</span>
    <span className="w-20">{formatDate(vi.invoiceDate, '—')}</span>
    <span className="w-28 text-right">{formatCurrency(vi.total, vi.currency, { ceil: false })}</span>
    <span className="w-40 truncate">{vi.vessels.join(', ') || '—'}</span>
    <span className="flex-1 truncate text-slate-500">{vi.vendorName}</span>
    {vi.matches && (
      <span className="px-2 py-0.5 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 font-medium whitespace-nowrap">
        {matchLabel}
      </span>
    )}
  </>
);
